module.exports = __webpack_public_path__ + "static/media/building.e1652c29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/building.svg
// module id = 118
// module chunks = 0